import { render, staticRenderFns } from "./UserTrendSearchFormInput.vue?vue&type=template&id=6bbd7472&scoped=true"
import script from "./UserTrendSearchFormInput.vue?vue&type=script&lang=ts"
export * from "./UserTrendSearchFormInput.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendSearchFormInput.vue?vue&type=style&index=0&id=6bbd7472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd7472",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/form/user-trend-search-form-input.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2Fform%2FUserTrendSearchFormInput.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports